export default __webpack_public_path__ + "static/media/location.665aeeb7.svg";